import { CommonActionType } from '../common/common-actions';
export const TenantActionType = {
    ...CommonActionType,
    LIST_TENANTS: 'LIST_TENANTS',
    LIST_TENANTS_SUCCESS: 'LIST_TENANTS_SUCCESS',
    LIST_TENANTS_ERROR: 'LIST_TENANTS_ERROR',
    SELECT_TENANT_ERROR: 'SELECT_TENANT_ERROR',
};
